import { createUseTranslation } from "core/session/translation";

export const useColorSelectorTranslation = createUseTranslation({
  en: {
    textColorLabel: "Text Color",
  },
});
